<template>
  <div class="school-bank">
    <div class="mt-2 row justify-content-center">
      <div class="col-12">
        <b-card title="Bank">
          <div class="mb-1">
            <b>Please only add a bank if you intend to accept online fee payments.</b>
          </div>
          <validation-observer
            ref="bankForm"
            v-slot="{invalid}"
          >
            <div class="row">
              <div class="col-md-4">
                <lenon-select
                  v-model="bankToSave.bank_code"
                  rules="required"
                  label="Bank Name"
                  name="bank_code"
                  :options="banks"
                  label-name="name"
                  value-name="id"
                  placeholder="Select your Bank"
                />
              </div>
              <div class="col-md-4">
                <lenon-input
                  v-model="bankToSave.account_number"
                  rules="required"
                  label="Account Number"
                  name="account_number"
                  placeholder="Enter your bank account #"
                />
              </div>
              <div class="col-md-4">
                <lenon-input
                  v-model="bankToSave.account_name"
                  rules="required"
                  label="Account Holder Name"
                  name="account_name"
                  placeholder="eg. Prince Osei"
                />
              </div>
            </div>
            <div class=" text-bolder text-danger mb-1">
              <small><b>All payouts go to this bank, change anytime.</b></small><br>
            </div>
            <div class="text-bolder">
              <div><b>This bank account is for the purposes of receiving payments made by parents through the mobile app (USSD coming soon), you need to understand the following terms & conditions associated with online fee payments, accepting online fee payments means you agree to them.</b></div><br>
            </div>
            <div class="mb-2 text-bolder">
              <ul>
                <li>All online fee payments made through the Lenon app or our USSD channel will reflect in the provided bank account within 48 hours.</li>
                <li>To ensure you receive all fee payments in full(without deducting transactional charges), Lenon automatically passes transactional charges plus a 1% service charge to parents. For this reason, parents will see the fee amount plus the extra charges on the checkout page.</li>
              </ul>
            </div>
            <lenon-button
              name="update-bank"
              label="Save"
              class="float-right"
              :disabled="invalid"
              :loading="bankFormLoading"
              @onClick="saveBank()"
            />
          </validation-observer>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import showToast from '@/lenon/mixins/showToast'
import LenonSelect from '@/lenon/components/LenonSelect.vue'
import LenonInput from '@/lenon/components/LenonInput.vue'
import LenonButton from '@/lenon/components/LenonButton.vue'
import { ValidationObserver } from 'vee-validate'
import LenonResponsive from '@/lenon/components/LenonResponsive.vue'
import { SAVE_BANK_M } from '@/graphql/mutations'

export default {
  name: 'SchoolBank',
  components: {
    LenonResponsive,
    LenonButton,
    LenonInput,
    LenonSelect,
    BCard,
    ValidationObserver,
  },
  mixins: [showToast],
  data() {
    return {
      bankFormLoading: false,
      bankToSave: {
        bank_code: null,
        account_number: null,
        account_name: null,
      },
    }
  },
  computed: {
    bank() {
      const b = this.$store.getters['auth/bank']
      return {...b,id:b.bank_code}
    },
    banks() {
      return this.$store.getters['auth/banks']
    },
  },
  mounted() {
    this.bankToSave = { ...this.bankToSave, ...this.bank }
  },
  methods: {
    saveBank() {
      this.bankFormLoading = true
      delete this.bankToSave.id
      this.bankToSave.bank_code = +this.bankToSave.bank_code
      this.$apollo.mutate({
        mutation: SAVE_BANK_M,
        variables: { input: this.bankToSave },
      }).then(res => {
        this.bankFormLoading = false
        this.$store.commit('auth/updateBank', res.data.saveBank)
        this.showSuccess('Saved Successfully')
      }).catch(err => {
        this.bankFormLoading = false
        this.showError('Something went wrong, Make sure details are valid, otherwise contact support.')
      })
    },
  },
}
</script>

<style scoped>

</style>
